<template>
    <v-container v-if="userData" class="app-page-container profile-area">
      <v-card class="shadow-none app-page-card">
        <v-card-title>
          My profile
          <v-spacer></v-spacer>
          <small>{{userData.email}}</small>
        </v-card-title>
        <v-card-text>
          <v-col cols="12">
            <v-row justify="center" no-gutters>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-text-field label="Name:" 
                  style="margin:10px"
                  :rules="nameRules"
                  v-model="userData.name"></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-text-field label="Surname:" 
                  style="margin:10px"
                  :rules="nameRules"
                  v-model="userData.surname"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Nickname:" 
                  style="margin:10px"
                  v-model="userData.nickname"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-container>
                  <v-row>
                      <v-col cols="8"> 
                          <v-combobox
                            v-model="userData.groups"
                            :items="myGroups"
                            :search-input.sync="search1"
                            label="Primary group"
                            placeholder="Start typing to Search"
                          ></v-combobox>
                      </v-col>
                      <v-col cols="4"> 
                        <p></p>
                        <v-btn class="white--text" color="primary" x-small @click="toGroups()">to Groups</v-btn>
                      </v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-select
                  style="margin:10px"
                  v-model="country"
                  :items="myCountries"
                  label="Country:"
                >Select country</v-select>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
              <v-select
                  style="margin:10px"
                  v-model="lang"
                  :items="myLanguages"
                  label="Environment language:"
                >Select environment language</v-select>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-select
                  style="margin:10px"
                  v-model="student_type"
                  :items="student_types"
                  label="Student type:"
                >Select student type</v-select>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6">
                <v-slider
                    style="margin:10px"
                    v-model="userData.yob"
                    :rules="rules.age"
                    :label="getAge()"
                    hint="Be honest, please."
                    :min="1940"
                    :max="endYear"
                    thumb-label
                  ></v-slider>
              </v-col>

              <v-col cols="12">
                  <v-radio-group class="profile-theme-switcher">
                      <h4>Themes</h4>
                      <v-combobox 
                          class="theme-switcher-combobox"
                          v-model="theme_selection"
                          :items="available_themes"
                          item-text="label"
                          item-value="value"
                          label="Choose the appearance of Priscilla across all of your learn spaces."
                          :change="changeTheme(theme_selection)"
                          outlined>
                        <template slot="item" slot-scope="data" >
                          <img class="theme-switcher-combobox-item__icon" :src="require('@/assets/img/icons/'+ data.item.value +'.svg')"><span class="theme-switcher-combobox-item__label"> {{data.item.label}}</span>
                        </template>
                      </v-combobox>
                  </v-radio-group>
              </v-col>

          <v-col cols="12">
            <p align="center" v-if="feedback" style="color: red">{{feedback}}</p>
          </v-col>
          <v-col cols="12" class="card-action-bar">
            <v-btn @click="saveChanges()" class="btn-style btn-primary">Save changes</v-btn>
          </v-col>
        </v-row>
      </v-col> 
      </v-card-text>
        
      </v-card>
    </v-container>
</template>

<script>
import axios from '../../axios-auth.js'
// import {mapGetters} from 'vuex'

  export default {
    data () {
      return {
        feedback: '', 
        languages: null,
        age: 0,
        myLanguages: [],
        nameRules: [
            v => !!v || 'The value is required',
            v => (v && v.length >= 2 && v.length <= 40) || 'The value must be 2-40 characters',
          ],          
        lang: '',
        countries: null,
        myCountries: [],
        myGroups: [],
        country: '',
        search1: '',
        endYear: 0,
        show1 : false,
        userData: null,
        student_types: ['teen student','university student'],
        student_type: 'university student',
        rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 5 || 'Min 5 characters'
        },
        theme_selection: null,
        available_themes: [],
      }
    },
    methods: {
      saveChanges () {
        this.$store.commit('setFeedback', null)
        this.feedback = null
        if (this.userData.name.length < 2) { 
          this.feedback = "Name is too short." 
          return 
        }
        if (this.userData.surname.length < 2) {
          this.feedback = "Surname is too short."
          return
        }

        if (this.userData.yob == 1940) {
          this.feedback = "Please set your age - content is dependent on age too."
          return
        }  

        var _nick = this.userData.nickname
        if (_nick.length < 2) _nick = this.userData.name + " " + this.userData.surname
        var _country = this.countries[this.myCountries.indexOf(this.country)].id
        var _lang = this.languages[this.myLanguages.indexOf(this.lang)].id

        const data = {
          name: this.userData.name,
          surname : this.userData.surname,
          country :  _country,
          lang: _lang,
          nick: _nick,
          group: this.userData.groups,
          age: this.userData.yob,
          content_type_id: this.student_types.indexOf(this.student_type) + 1,
          theme_id: this.theme_selection.id
        }
        // eslint-disable-next-line
        // console.log(data)
        axios.post('/profile-change', data, this.$store.getters.getAxiosConfig)
          .then((response) => {
            if (response.data.message == 'OK') { 
              this.feedback = "Data saved."   
              this.$router.push({name:'dashboard'})  
              /*
              axios.get('/get-profile-data', this.$store.getters.getAxiosConfig)
                  .then((response) => {
                    this.userData = response.data
                    })
                  .catch(error => {
                      this.feedback = error.message 
                  })  */
            } else {
              this.feedback = response.data.message
            }          
           })
          .catch(error => {
              this.feedback = error.message 
          })
      },
      initData() {
        var d = new Date()
        this.endYear = d.getFullYear()

        this.$store.commit('setFeedback', null)

        axios.get('/get-registration-data', this.$store.getters.getAxiosConfig)
        .then((response) => {
          this.languages = response.data.languages
          this.myLanguages = []
          for(let i = 0; i < this.languages.length; i++) {
            this.myLanguages.push( this.languages[i].name)
          }
          this.lang = this.myLanguages[0]
          //************************ */
          this.countries = response.data.countries
          this.myCountries = []
          for(let i = 0; i < this.countries.length; i++) {
            this.myCountries.push( this.countries[i].country_name)
          }
          this.country = this.myCountries[0]
          //************************ */
          this.groups = response.data.groups
          this.myGroups = []
          for(let i = 0; i < this.groups.length; i++) {
            this.myGroups.push( this.groups[i].group_name)
          } 
          //************************ */ 
          this.available_themes = []
          for(let i = 0; i < response.data.themes.length; i++) {
            this.available_themes.push({id: response.data.themes[i].id,
                                        "label": response.data.themes[i].description,
                                        "value": response.data.themes[i].theme_name})
            this.theme_selection = this.available_themes[0]
          } 
          axios.get('/get-profile-data', this.$store.getters.getAxiosConfig)
                  .then((response) => {
                    this.userData = response.data
                    // eslint-disable-next-line
                    // console.log(this.userData)
                    // find country 
                    for(let x = 0; x < this.countries.length; x++) {
                      if (this.countries[x].id == this.userData.country_id) {
                        this.country = this.myCountries[x]
                        break
                      }
                    }
                    // find lang                                      
                    for(let x = 0; x < this.languages.length; x++) {
                      if (this.languages[x].id == this.userData.pref_lang_id) {
                        this.lang = this.myLanguages[x]
                        break
                      }
                    }
                    // set student type                    
                    this.student_type = this.student_types[this.userData.content_type_id-1]
                    // theme
                    for(let x = 0; x < this.available_themes.length; x++) {
                      if (this.available_themes[x].id ==  this.userData.theme_id)  {
                        this.theme_selection = this.available_themes[x]
                        break
                      }                        
                     }
                  })
                  .catch(error => {
                    this.$store.commit('setFeedback', error)          
                  })
          })
          .catch(error => {
            this.$store.commit('setFeedback', error)          
          })
      },
      getAge() {
        return "Y.of birth: " + this.userData.yob
      },
      toGroups() {
        this.$router.push({name:'groups', params: {}}) 
      },
      changeTheme(theme_preference) {
        // ps: tato zmena je ucinna a dokaze byt aktivna az do doby refreshu pouzivatelom alebo kliknutim na breadcrumbs
        // preto je dolezite na tuto zemnu nadviazat aj ulozenou preferenciou z db, pomocou ktorej nasetujeme state - theme_preference
        this.$store.commit('setThemePreference', theme_preference.value)
      }
    },
    mounted() {
      this.initData()
    }
  }
</script>


<style>

</style>
